import React from "react";
import * as styles from "./SubscribeToNewsletter.module.scss";
import {
  BlockContentValue,
  PartialSanityImageType
} from "@silversea-ssc/ui-components-react";
import SubscribeInlineForm from "components/SubscribeToNewsletter/SubscribeInlineForm/SubscribeInlineForm";
import { FormDisclaimerFragment } from "types/graphql-types";
import EmotionalLauncher from "components/EmotionalLauncher/EmotionalLauncher";
import { INavLink } from "components/HeaderNavBar/type";

type Props = {
  backgroundImage: PartialSanityImageType | undefined;
  title: string;
  content: BlockContentValue | undefined;
  formDisclaimerContent: FormDisclaimerFragment | undefined;
  formName: string;
  privacyPolicyUrl: INavLink;
  offerPageUrl: string | undefined;
};

const SubscribeToNewsletter: React.FC<Props> = ({
  backgroundImage,
  title,
  content,
  formDisclaimerContent,
  formName,
  privacyPolicyUrl,
  offerPageUrl
}) => (
  <EmotionalLauncher
    backgroundImage={backgroundImage}
    title={title}
    content={content}
    dataContentName={"subscribe_to_newsletter_section"}
  >
    <div className={styles.form}>
      <SubscribeInlineForm
        formVariant="default"
        formButtonVariant="primary"
        formTitle={title}
        formContent={content}
        formName={formName}
        formDisclaimerContent={formDisclaimerContent}
        privacyPolicyUrl={privacyPolicyUrl}
        offerPageUrl={offerPageUrl}
      />
    </div>
  </EmotionalLauncher>
);

export default SubscribeToNewsletter;
